import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookSquare, faTwitterSquare, faInstagramSquare } from "@fortawesome/free-brands-svg-icons"

class SocialLinks extends React.Component {
  render () {
    return (
      <div
        className='flex-container align-center flex-dir-column'
      >

        <p className='text-center lead mmb'>
          Join the conversation on social media with <span className='bold italic lead block h1 nmb'>#LandReform</span>
        </p>

        <div className='flex-container align-center'>

          <a
            href='https://www.facebook.com/MYLANDSCOT/'
            rel='nofollow'
            target='_blank'
          >
            <FontAwesomeIcon
              icon={faFacebookSquare}
              className='social-icon sm nmt'
            />
          </a>
          <a
            href='https://twitter.com/MYLANDSCOT/'
            rel='nofollow'
            target='_blank'
          >
            <FontAwesomeIcon
              icon={faTwitterSquare}
              className='social-icon sm nmt'
            />
          </a>
          <a
            href='https://www.instagram.com/MYLANDSCOT/'
            rel='nofollow'
            target='_blank'
          >
            <FontAwesomeIcon
              icon={faInstagramSquare}
              className='social-icon sm nmt'
            />
          </a>

        </div>

      </div>
    );
  }
}

export default SocialLinks
